import { callApi } from 'src/core/callApi';

const MANAGE_PUBLIC_API_KEY_URL =
  'https://b7xbzjxjw1.execute-api.us-east-2.amazonaws.com/prod/managePublicApiKey';
const REPORT_PUBLIC_API_USAGE_URL =
  'https://hq1yfu0atg.execute-api.us-east-2.amazonaws.com/prod/reportPublicApiUsage';
const VALIDATION_API_URL =
  'https://gat6ftpf82.execute-api.us-east-2.amazonaws.com/prod/addPublicApiCredits';

export const createApiKey = async (keyName: string) => {
  try {
    const response = await callApi(
      MANAGE_PUBLIC_API_KEY_URL,
      { body: { key_name: keyName } },
      true,
      false,
      '',
      'POST',
      true
    );
    if (!response.error) {
      /*
      response.message object with the following format: {
            "key_id": key_id,
            "key_hash": key_hash,
            "key_name": key_name,
            "user_id": email,
            "status": "active",
            "created_at": int(time.time()),
            "credits_remaining": key_credits_remaining,
            "tier": DEFAULT_TIER,
        }
     */
      return response.message;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error creating API key: ', error);
    return null;
  }
};

export const getApiKeyOverview = async () => {
  try {
    const response = await callApi(MANAGE_PUBLIC_API_KEY_URL, {}, true, false, '', 'GET', true);
    if (!response.error) {
      /*
      response.message object with the following format: {
            "key_id": key_id,
            "key_hash": key_hash,
            "key_name": key_name,
            "user_id": email,
            "status": "active",
            "created_at": int(time.time()),
            "credits_remaining": key_credits_remaining,
            "tier": DEFAULT_TIER,
        }
     */
      return response.message;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error getting API key overview: ', error);
    return null;
  }
};

export const reportPublicApiUsage = async (days: number) => {
  try {
    const response = await callApi(REPORT_PUBLIC_API_USAGE_URL, { queryParams: { days } }, true);
    if (!response.error) {
      /*
      response.message object with the following format: {
            "grouped_usage_data": {
                "2025-09-23": {
                    "/markets/search": 2,
                    "/markets/lookup": 3,
                    "/markets/summary": 1,
                    "/markets/metrics/all": 2,
                    "/listings": 1,
                },
                "2025-09-24": {
                    "/markets/search": 1,
                    "/markets/lookup": 2,
                    "/markets/metrics/revenue": 1,
                    "/listings/search/market": 2,
                },...more dates and endpoints
            },
            "total_usage_count": 20,
            "total_cost": 20,
            "call_history": [
              { "timestamp": 1730000000, "route_key": "/markets/search", "cost": 0.01, "status": "success" },
              { "timestamp": 1729999999, "route_key": "/markets/lookup", "cost": 0, "status": "failed", "deny_reason": "insufficient_credits" },
            ],
        }
     */
      return response.message;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error reporting public API usage: ', error);
    return null;
  }
};

export const getStripeCheckoutUrl = async (credits: number) => {
  const url =
    'https://2iqbzo7zv7.execute-api.us-east-2.amazonaws.com/default/createStripeCheckoutSession';

  const currentURL = window.location.href;
  const currentBaseURL = currentURL.split('?')[0];

  const response = await callApi(
    url,
    {
      body: {
        currency: 'usd',
        productName: 'API Credits',
        productDescription: `$${credits}.00 in API credits`,
        price: `${credits}00`,
        successURL: `${currentBaseURL}?session_id={CHECKOUT_SESSION_ID}`,
        cancelURL: `${currentBaseURL}?session_id=cancel`,
        stripeAccount: 'airbtics_us',
        // isTest: true,
      },
    },
    true,
    false,
    '',
    'POST',
    true
  );

  if (!response.message.error) {
    return response.message.redirect_url;
  } else {
    throw new Error(`Error fetching Stripe checkout URL: ${response.message.error}`);
  }
};

export const validatePayment = async (sessionId: string) => {
  try {
    const response = await callApi(
      VALIDATION_API_URL,
      {
        body: {
          session_id: sessionId,
          // isTest: true,
          stripeAccount: 'airbtics_us',
        },
      },
      true,
      false,
      '',
      'POST',
      true
    );

    if (!response.error) {
      return response.message.success;
    } else {
      return false;
    }
  } catch (error) {
    console.error('Error validating payment: ', error);
    return false;
  }
};
